import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col, Card, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, FormGroup, Input, Label } from "reactstrap"
import { providerPrefix } from "configs/routePrefix"
import { AvForm, AvField } from 'availity-reactstrap-validation'
import Select from "react-select"
import { Stepper } from 'react-form-stepper'
import MyMap from "components/Common/google-map/MyMap"
import { Gogovernorates } from "Enums/fixedData"
import SelectOptions from "components/SelectOptions"
import UnitTypesService from "services/Provider/UnitTypesService"
import CitiesService from "services/Provider/CitiesService"
import ResaleService from "services/Provider/ResaleService"
import PaymentPlan from "./PaymentPlan"
import { SuccessOk } from "configs/statusCode"
import SellerService from "services/Provider/SellerService"
import Language from "Enums/Language"
import "./styles.scss"
import StatusModal from "../StatusModal"
import DeleteModal from "components/Common/DeleteModal"
import { useSelector } from "react-redux"

import {
    FileMetaData,
    FilePreviewContainer,
    ImagePreview,
    PreviewContainer,
    PreviewList,
    RemoveFileIcon,
    ShowContent,
} from "components/Common/file-upload/file-upload.styles"

const CreateResale = (props) => {
    const [formStep, setFormStep] = useState(0)
    const [formData, setFormData] = useState({})
    const [mediaIds, setMediaIds] = useState([])
    const [contractImages, setContractImages] = useState([])
    const [termsAndConditions, setTermsAndConditions] = useState([])
    const [nationalId, setNationalId] = useState([])
    const [videosIds, setVideosIds] = useState([])
    const [cityOptions, setCityOptions] = useState([])
    const [unitTypeOptions, setUnitTypeOptions] = useState([])
    const [clientOptions, setClientOptions] = useState([])
    const [loading, setLoading] = useState(false)
    const [statusmodal, setStatusModal] = useState(false)
    const resaleService = new ResaleService()
    const id = props.match.params.id
    const [deleteModal, setDeleteModal] = useState(false)
    const [dropdownActions, setDropdownActions] = useState(false)
    const toggle = () => setDropdownActions(prevState => !prevState)
    const AuthData = useSelector(state => state.Auth)
    const [showMap, setShowMap] = useState(false)
    const isExist = (data) => AuthData.permissions.includes(data)

    // const usePathname = () => {
    //     return location.pathname.substring(7, 11)
    // }
    // const handleCloseModal = (action, response) => {
    //     setDeleteModal(false)
    //     if (action === "delete") {
    //         props.history.push(`${providerPrefix}/resale`)
    //     }
    // }

    

    // const getEditResaleData = async () => {
    //     const response = await compoundService.getDropDown()
    //     const newOptions = response.data?.map(item => {
    //         return {
    //             label: item.name.en,
    //             value: item.id
    //         }
    //     })
    //     //const compoundName = newOptions.find(item => item.label === res.data.compound_name)
    //     
    // }

    // useEffect(()=>{
    //     getEditResaleData()
    // },[])

    useEffect(() => {
        resaleService.find(id).then(res => {
            if (res && res.status === SuccessOk) {
                setFormData({
                    payment_plan: res.data.payment_plan,
                    in_compound: res.data.in_compound,
                    ar: res.data.name.ar,
                    en: res.data.name.en,
                    ru: res.data.name.ru,
                    zh: res.data.name.zh,
                    amenities: res.data.amenities,
                    bank_account: res.data.bank_account,
                    selectedFinishingType: {
                        label: res.data.finishing_type.name,
                        value: res.data.finishing_type.id,
                    },
                    selectUnitType: {
                        label: res.data.unit_type.name.en,
                        value: res.data.unit_type.id,
                    },
                    bedRoom_num: res.data.bedrooms,
                    floor: res.data.floor,
                    bathroom_num: res.data.bathrooms,
                    selectedCity: {
                        ...res.data.location.City,
                        label:res.data.location.City.en,
                    },
                    governorate: {
                        ...res.data.location.governorate,
                        label: res.data.location.governorate.en,
                    },
                    facing: res.data.facing,
                    lat: res.data.location?.lat,
                    lng: res.data.location.lang,
                    unit_size: res.data.total_built_up_area,
                    
                    descrip_ar: res.data.description.ar,
                    descrip_en: res.data.description.en,
                    descrip_ru: res.data.description.ru,
                    descrip_zh: res.data.description.zh,
                    address_ar: res.data.location.street_address.ar,
                    address_en: res.data.location.street_address.en,
                    address_ru: res.data.location.street_address.ru,
                    address_zh: res.data.location.street_address.zh,
                    client_id: {
                        label:`${res.data.client.id} / ${res.data.client.name}`,
                        value:res.data.client.id 
                    },
                    furnishing: res.data.furnishing,
                    status: res.data.status,
                    compound_name: res.data?.compound?.name,
                    total_land_area: res.data?.total_land_area,
                    area: res.data.area.name
                })
                setContractImages([...res.data.contracts])
                setMediaIds([...res.data.images])
                setVideosIds([...res.data?.videos])
                setNationalId([...res.data.national_ids_images])
                setTermsAndConditions([...res.data.terms_and_conditions])
                setShowMap(!!res.data.location.lat && !!res.data.location.lang ? true : false )
                //setShouldGetData(false)
            }
        })
        
    }, [])
    useEffect(() => {
        // template string inside query Selectpor
        const value = 2 * formStep + 1
        const element = document.querySelector(`.RFS-Label-d${value}`)
        if (element) {
            element.style.fontWeight = "700"
        }
    }, [formStep])




    const nextFormStep = (step) => {
        setFormStep(formStep + 1)
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }

    const lastFormStep = () => {
        setFormStep(formStep - 1)
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }
    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const renderButton = () => {
        if (formStep === 4) {
            return (
                <>
                    <Col md={8}>
                        <Col md={3}>
                            <button
                                className="btn btn-light w-100 border-2 border-success text-success"
                                onClick={() => props.history.push(`${providerPrefix}/resale`)} >Cancel</button>
                        </Col>
                        <Col md={6}></Col>
                    </Col>
                    <Col md={2} className="d-flex flex-row-reverse ">
                        <button className="btn btn-light w-100 border-2 border-success text-success" onClick={lastFormStep}>
                            Back</button>
                    </Col>
                    <Col md={2} className="d-flex flex-row-reverse ">
                        <button
                            type="submit"
                            className="btn btn-success w-100 "
                            disabled={loading ? true : false}
                        >
                            Submit
                        </button>
                    </Col>
                </>
            )
        } else if (formStep === 0) {
            return (
                <>
                    <Col md={8} >
                        <Col md={3}>
                            <button
                                className="btn btn-light w-100 border-2 border-success text-success"
                                onClick={() => props.history.push(`${providerPrefix}/resale`)} >Cancel</button>
                        </Col>
                        <Col md={6}></Col>
                    </Col>
                    <Col md={2} className="d-flex flex-row-reverse"></Col>
                    <Col md={2} className="d-flex flex-row-reverse">
                        <button type="submit" className="btn btn-success   w-100 ">Next</button>
                    </Col>
                </>
            )
        } else {
            return (
                <>
                    <Col md={8} >
                        <Col md={3}>
                            <button
                                className="btn btn-light w-100 border-2 border-success text-success"
                                onClick={() => props.history.push(`${providerPrefix}/resale`)} >Cancel</button>
                        </Col>
                        <Col md={6}></Col>
                    </Col>
                    <Col md={2} className="d-flex flex-row-reverse">
                        <button className="btn btn-light w-100 border-2 border-success text-success" onClick={lastFormStep}>
                            Back</button></Col>
                    <Col md={2} className="d-flex flex-row-reverse">
                        <button type="submit" className="btn btn-success   w-100 ">Next</button>
                    </Col>
                </>
            )
        }
    }
    const ButtonCard = () => {
        return (
            <Row>
                <Card>
                    <CardBody>
                        <Row className="d-flexjustify-content-between">
                            {renderButton()}
                        </Row>
                    </CardBody>
                </Card >
            </Row>
        )
    }

    return (
        <>
            <div className='page-content'>
                <MetaTags>
                    <title>{id ? "Update Resale" : "create Resale"}</title>
                </MetaTags>
                <Container  >
                    <Row className="mx-4">
                        <Col md={6}>
                            <h4>View Resale</h4>
                        </Col>
                        {/* {isExist("resale.edit") || isExist("resale.delete") ? <Col md={6} className="d-flex flex-row-reverse">
                            
                        </Col>:null} */}
                        <Col md={6} className="d-flex flex-row-reverse">
                        <Dropdown className="dropdownWidth removebtnhover" color="light" isOpen={dropdownActions} toggle={toggle}>
                                <DropdownToggle caret>
                                    <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                                </DropdownToggle>
                                <DropdownMenu>
                                <DropdownItem onClick={() => setStatusModal(!statusmodal)}>Change Status</DropdownItem>
                                <DropdownItem className="text-danger" onClick={() => setDeleteModal(!deleteModal)}>Remove Resale</DropdownItem>
                                {/* {isExist("resale.edit") ? :null} */}
                                {/* {isExist("resale.delete") ? :null} */}
                                 </DropdownMenu>
                            </Dropdown>
                        </Col>
                        
                    </Row>
                    <Row className="position-relative .resale-stepper">
                        <div style={{ width: "10.5%", height: "0.4em", position: "absolute", top: "29%", left: "10px", background: "#556ee6", }}></div>
                        <Stepper
                            steps={[
                                { label: "Resale Information" },
                                { label: "Photos" },
                                { label: "Location" },
                                { label: "Contract Images & National Id" },
                                { label: "Payment Plan" }
                            ]}
                            activeStep={formStep}
                            connectorStateColors={true}
                            styleConfig={{
                                activeBgColor: 'white',
                                activeTextColor: '#495057',
                                inactiveBgColor: '#FFFFFF',
                                inactiveTextColor: '#495057',
                                completedBgColor: '#FFFFFF',
                                completedTextColor: '#495057',
                                size: '3em',

                            }}
                            connectorStyleConfig={{
                                size: '.4em',
                                completedColor: '#556ee6',
                                activeColor: '#556ee6',
                                disabledColor: "#f8f8fb",
                                disabledColor: "#f6f6f6"
                            }}

                            className={'stepper'}
                            stepClassName={'stepper__step'}
                        />
                    </Row>
                </Container  >
                {formStep === 0 &&
                    <AvForm onValidSubmit={(e, v) => nextFormStep()}>
                        <Container  >
                            <Card>
                                <CardBody>
                                    <Row >
                                        <h4>Resale Information</h4>
                                    </Row>
                                    <Row className="mb-4 bg-light p-2" >
                                        <Col md={6} className="my-3"><h6>Listing in Compound</h6></Col>
                                        <Col md={6} className="d-flex flex-row-reverse">
                                            <div className='form-check form-switch form-switch-md mb-1'>
                                                <AvField
                                                    name='in_compound'
                                                    checked={formData.in_compound}
                                                    value={formData.in_compound}
                                                    type='checkbox'
                                                    className='form-check-input'
                                                    disabled
                                                />
                                            </div>
                                        </Col>
                                        {formData.in_compound && <Col md={6}  >
                                            <label>Compound Name</label>
                                            <AvField
                                                readOnly
                                                name='compound_name'
                                                className='mb-3 '
                                                // onChange={(data) => {
                                                //     setFormData({ ...formData, compound_name: data })
                                                // }}
                                                value={formData.compound_name}
                                            />
                                        </Col>}
                                    </Row>
                                    <Row>
                                        <Row>
                                            {Language.LIST.map((lan, index) => {
                                                return (
                                                    <Col md={6} key={index} >
                                                        <AvField
                                                            className="mb-3"
                                                            name={lan.name}
                                                            label={` Name (${lan.name})`}
                                                            bsSize="lg"
                                                            value={formData[`${lan.name}`]}
                                                            onChange={(e => handleFieldChange(e))}
                                                            required={lan.name === "en" ? true : false}
                                                            placeholder={lan.name === "en" ? 'Resale Name' : lan.name === "ar" ? "اسم الوحدة" : lan.name === "zh" ? "開羅" : "Каир"}
                                                            readOnly
                                                        />
                                                    </Col>
                                                )
                                            })}

                                            <Col md={6}>
                                                <SelectOptions
                                                    isDisabled={true}
                                                    label={"Client Id"}
                                                    placeholder={'Select'}
                                                    options={clientOptions}
                                                    handleSelectChange={(data) => {
                                                        setFormData({ ...formData, client_id: data })
                                                    }}
                                                    selectedOption={formData.client_id}
                                                    Service={SellerService}
                                                    setOptions={(options) => {
                                                        setClientOptions(options)
                                                    }}
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <SelectOptions
                                                    isDisabled={true}

                                                    label='Unit Type'
                                                    placeholder='Select'
                                                    options={unitTypeOptions}
                                                    handleSelectChange={(data) => {
                                                        setFormData({ ...formData, selectUnitType: data })
                                                    }}
                                                    selectedOption={formData.selectUnitType}
                                                    Service={UnitTypesService}
                                                    setOptions={(options) => {}}
                                                />
                                            </Col>
                                        </Row>
                                    </Row>
                                    <Row>
                                        {Language.LIST.map((lan, index) => {
                                            return (
                                                <Col md={12} key={index} >
                                                    <AvField
                                                        className="mb-3"
                                                        name={lan.descrip_name}
                                                        label={`Description (${lan.name})`}
                                                        bsSize="lg"
                                                        value={formData[`${lan.descrip_name}`]}
                                                        onChange={(e => handleFieldChange(e))}
                                                        required={false}
                                                        minLength={formData[`${lan.descrip_name}`] !== "" && 2}
                                                        type="textarea"
                                                        placeholder={lan.name === "en" ? 'Description' : lan.name === "ar" ? " الكومبوند" : lan.name === "zh" ? "開羅" : "Каир"}
                                                        readOnly
                                                    />
                                                </Col>
                                            )
                                        })}
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <Row >
                                        <Col md={6}  >
                                            <AvField
                                                className="mb-3"
                                                name={"unit_size"}
                                                label={"Unit Size"}
                                                bsSize="lg"
                                                value={formData.unit_size}
                                                onChange={(e => handleFieldChange(e))}
                                                placeholder={'Size'}
                                                type="number"
                                                min={"1"}
                                                readOnly

                                            />
                                        </Col>
                                        <Col md={6}  >
                                            <AvField
                                                className="mb-3"
                                                name={"floor"}
                                                label={"Unit Floors"}
                                                bsSize="lg"
                                                value={formData.floor}
                                                onChange={(e => handleFieldChange(e))}
                                                required
                                                placeholder={'floor'}
                                                type="number"
                                                readOnly
                                            />
                                        </Col>
                                        {formData?.total_land_area && <Col md={6}  >
                                            <AvField
                                                className="mb-3"
                                                name={"total_land_area"}
                                                label={"Total Land Area"}
                                                bsSize="lg"
                                                value={formData.total_land_area}
                                                placeholder={'floor'}
                                                type="number"
                                                readOnly
                                            />
                                        </Col>}
                                        <Col md={6}>
                                            <label>Facing</label>
                                            <AvField
                                                readOnly
                                                placeholder='Select'
                                                name='facing'
                                                className="mb-3"
                                                // onChange={(data) => {
                                                //     setFormData({ ...formData, facing: data })
                                                // }}
                                                value={formData.facing}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <label>Furnishing</label>
                                            <AvField
                                                readOnly
                                                name='furnishing'
                                                className='mb-3'
                                                // onChange={(data) => {
                                                //     setFormData({ ...formData, furnishing: data })
                                                // }}
                                                value={formData.furnishing}
                                            />
                                        </Col>
                                        <Col md={6}>
                                            <AvField
                                                readOnly
                                                value={formData.selectedFinishingType?.label}
                                                label='Finishing'
                                                name='finishing'
                                                className='mb-3'
                                                //placeholder='Select'
                                                //options={FinishingOptions}
                                                // handleSelectChange={(data) => {
                                                //     setFormData({ ...formData, selectedFinishingType: data })
                                                // }}
                                                // selectedOption={formData.selectedFinishingType}
                                                // Service={FinishingTypesService}
                                                // setOptions={(options) => {
                                                //     setFinishingOptions(options)
                                                // }}
                                            />
                                        </Col>

                                    </Row>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <Row >
                                        <Col md={6}  >
                                            <AvField
                                                className="mb-3"
                                                name={"bedRoom_num"}
                                                label={"No. Of Bedrooms"}
                                                bsSize="lg"
                                                value={formData.bedRoom_num}
                                                onChange={e => handleFieldChange(e)}
                                                required
                                                placeholder={'bedRoom number'}
                                                type="number"
                                                min={"1"}
                                                max={"30"}
                                                readOnly
                                            />
                                        </Col>
                                        <Col md={6}  >
                                            <AvField
                                                className="mb-3"
                                                name={"bathroom_num"}
                                                label={"No. Of Bathrooms"}
                                                bsSize="lg"
                                                value={formData.bathroom_num}
                                                onChange={e => handleFieldChange(e)}
                                                required
                                                placeholder={'bathroom number'}
                                                type="number"
                                                min={"0"}
                                                max={"30"}
                                                readOnly
                                            />
                                        </Col>

                                    </Row>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <Row className="mb-4 bg-light p-2" >
                                        <Col md={6} className="my-3"><h6>Is the unit contain amenities?</h6></Col>
                                        
                                            <Select
                                                label='Compound '
                                                placeholder='Select'
                                                options={formData.amenities}
                                                className='mb-3 '
                                                onChange={() => {}}
                                                value={formData.amenities}
                                                isMulti={true}
                                            />
                                    </Row>
                                </CardBody>
                            </Card>
                        </Container>
                        <ButtonCard />
                    </AvForm>
                }
                {formStep === 1 &&
                    <AvForm onValidSubmit={(e, v) => nextFormStep()}>
                        <Container>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md={12}>
                                        <h5>Unit Images</h5>

                                        <FilePreviewContainer>
                                                <PreviewList>
                                                    {mediaIds.map((item, index) => {
                                                        return (
                                                            <PreviewContainer key={index}>
                                                                <div>
                                                                <ImagePreview
                                                                    src={item.path}
                                                                    alt={`file preview ${index}`}
                                                                />
                                                                 <FileMetaData>
                        {/* <span>{file.name}</span> */}
                        <aside>
                          {/* <span>{convertBytesToKB(file.size)} kb</span> */}
                    
                          <ShowContent
                            href={item.path}
                            target='_blank'
                            rel='noopener noreferrer'>
                            <RemoveFileIcon className='fas fa-eye' />
                          </ShowContent>
                        </aside>
                      </FileMetaData>
                      </div>
                                                            </PreviewContainer>
                                                        )
                                                    })}
                                                </PreviewList>
                                            </FilePreviewContainer>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            {videosIds.length > 0 &&
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md={12}>
                                        <h5>Unit Videos</h5>

                                        <FilePreviewContainer>
                                                <PreviewList>
                                                    {videosIds.map((item, index) => {
                                                        return (
                                                            <PreviewContainer key={index}>
                                                                <div>
                                                                <ImagePreview
                                                                    src={item.path}
                                                                    alt={`file preview ${index}`}
                                                                />
                                                                <FileMetaData>
                                                                    <aside>
                                                                    <ShowContent
                                                                        href={item.path}
                                                                        target='_blank'
                                                                        rel='noopener noreferrer'>
                                                                        <RemoveFileIcon className='fas fa-eye' />
                                                                    </ShowContent>
                                                                    </aside>
                                                                </FileMetaData>
                                                                </div>
                                                            </PreviewContainer>
                                                        )
                                                    })}
                                                </PreviewList>
                                            </FilePreviewContainer>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            }
                        </Container>
                        <ButtonCard />
                    </AvForm>
                }

                {formStep === 2 && <AvForm onValidSubmit={(e, v) => nextFormStep()}>
                    <Container>
                        <Card>
                            <CardBody>
                                <Row className="mb-4">
                                    <Row>
                                        <h4>Location</h4>
                                    </Row>
                                    {formData.lat && formData.lng && <MyMap
                                        updateLocationPositions={() => { }}
                                        lat={formData.lat}
                                        lng={formData.lng}
                                    />}
                                </Row>
                                <Row className="mb-3 mx-1">
                                    {!!formData.lat && <FormGroup check>
                                        <Input
                                        id="exampleCheck"
                                        name="check"
                                        type="checkbox"
                                        checked={showMap}
                                        onChange={(e) => {
                                            setShowMap(e.target.checked)
                                            //updateLocationPositions('','')
                                        }}
                                        />
                                        <Label
                                        check
                                        for="exampleCheck"
                                        >
                                        Display Map in Resale
                                        </Label>
                                    </FormGroup>}
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <label>Governorate</label>
                                        <Select
                                            isDisabled={true}

                                            placeholder='Select'
                                            options={Gogovernorates}
                                            className='mb-3'
                                            onChange={(data) => {
                                                setFormData({ ...formData, governorate: data })
                                            }}
                                            value={formData.governorate}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <SelectOptions
                                            isDisabled={true}
                                            label='City'
                                            placeholder='Select'
                                            options={cityOptions}
                                            handleSelectChange={(data) => {
                                                setFormData({ ...formData, selectedCity: data })
                                            }}
                                            selectedOption={formData.selectedCity}
                                            Service={CitiesService}
                                            setOptions={(options) => {
                                                setCityOptions(options)
                                            }}
                                        />
                                    </Col>
                                    <Col md={6}>
                                                <AvField
                                                    className="mb-3"
                                                    name="area"
                                                    label={`Location`}
                                                    bsSize="lg"
                                                    value={formData.area}
                                                    readOnly
                                                />
                                            </Col>
                                    <Row>
                                        {Language.LIST.map((lan, index) => {
                                            return (
                                                <Col md={12} key={index} >
                                                    <AvField
                                                        className="mb-3"
                                                        name={lan.address_name}
                                                        label={`Address (${lan.name})`}
                                                        bsSize="lg"
                                                        value={formData[`${lan.address_name}`]}
                                                        onChange={(e => handleFieldChange(e))}
                                                        minLength={formData[`${lan.address_name}`] !== "" && 2}
                                                        required={lan.name === "en" ? true : false}
                                                        readOnly
                                                        placeholder={lan.name === "en" ? ' Address' : lan.name === "ar" ? "عنوان " : lan.name === "zh" ? "開羅" : "Каир"}
                                                    />
                                                </Col>
                                            )
                                        })}
                                    </Row>
                                </Row>
                            </CardBody>
                        </Card>
                    </Container>
                    <ButtonCard />
                </AvForm>}
                {formStep === 3 && <AvForm onValidSubmit={(e, v) => nextFormStep()}>
                    <Container>
                        <Row>
                            <Card>
                                <CardBody>
                                    <Row>
                                    <h5>Contract Images</h5>
                                        <Col md={12}>
                                            <FilePreviewContainer>
                                                <PreviewList>
                                                    {contractImages.map((item, index) => {
                                                        return (
                                                            <PreviewContainer key={index}>
                                                            <div>
                                                                <ImagePreview
                                                                    src={item.path}
                                                                    alt={`file preview ${index}`}
                                                                />
                                                                           <FileMetaData>
                        {/* <span>{file.name}</span> */}
                        <aside>
                          {/* <span>{convertBytesToKB(file.size)} kb</span> */}
                    
                          <ShowContent
                            href={item.path}
                            target='_blank'
                            rel='noopener noreferrer'>
                            <RemoveFileIcon className='fas fa-eye' />
                          </ShowContent>
                        </aside>
                      </FileMetaData>
                      </div>
                                                            </PreviewContainer>
                                                        )
                                                    })}
                                                </PreviewList>
                                            </FilePreviewContainer>

                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Row>
                        <Row>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md={12}>
                                        <h5>National Id Images</h5>
                                        <FilePreviewContainer>
                                                <PreviewList>
                                                    {nationalId.map((item, index) => {
                                                        return (
                                                            <PreviewContainer key={index}>
                                                            <div>
                                                                <ImagePreview
                                                                    src={item.path}
                                                                    alt={`file preview ${index}`}
                                                                />
                                                                           <FileMetaData>
                        {/* <span>{file.name}</span> */}
                        <aside>
                          {/* <span>{convertBytesToKB(file.size)} kb</span> */}
                    
                          <ShowContent
                            href={item.path}
                            target='_blank'
                            rel='noopener noreferrer'>
                            <RemoveFileIcon className='fas fa-eye' />
                          </ShowContent>
                        </aside>
                      </FileMetaData>
                      </div>
                                                            </PreviewContainer>
                                                        )
                                                    })}
                                                </PreviewList>
                                            </FilePreviewContainer>
                                            
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Row>
                        <Row>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md={12}>
                                        <h5>Terms and Conditions Pdf</h5>
                                        <FilePreviewContainer>
                                                <PreviewList>
                                                    {termsAndConditions.map((item, index) => {
                                                        return (
                                                            <PreviewContainer key={index}>
                                                            <div>
                                                                <ImagePreview
                                                                    src={item.path}
                                                                    alt={`file preview ${index}`}
                                                                />
                                                                           <FileMetaData>
                        {/* <span>{file.name}</span> */}
                        <aside>
                          {/* <span>{convertBytesToKB(file.size)} kb</span> */}
                    
                          <ShowContent
                            href={item.path}
                            target='_blank'
                            rel='noopener noreferrer'>
                            <RemoveFileIcon className='fas fa-eye' />
                          </ShowContent>
                        </aside>
                      </FileMetaData>
                      </div>
                                                            </PreviewContainer>
                                                        )
                                                    })}
                                                </PreviewList>
                                            </FilePreviewContainer>
                                            
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Row>
                        <Row>
                            <Col md={12}>
                            <AvField
                                    className="mb-3"
                                    name={`bank_account`}
                                    label={`Account Number`}
                                    bsSize="lg"
                                    value={formData.bank_account}
                                    type='text'
                                />
                            </Col>
                        </Row>
                    </Container>
                    <ButtonCard />
                </AvForm>}
                {formStep === 4 && <PaymentPlan
                    id={id}
                    data={formData}
                    finishHandler={() => props.history.push(`${providerPrefix}/resale`)}
                    updateFormData={setFormData}
                    loading={loading}
                >
                    <ButtonCard />
                </PaymentPlan>}
                <DeleteModal
                    open={deleteModal}
                    titleMsg={formData.en}
                    deletedItem={{ id }}
                    modelService={resaleService}
                    onCloseModal={(action) => handleCloseModal(action)}
                />
                {statusmodal ?<StatusModal
                    modal={statusmodal}
                    setShouldGetData={setShouldGetData}
                    toggle={() => {
                        setStatusModal(!StatusModal)
                    }}
                    editResale={{
                        status: formData.status,
                        id: id
                    }}
                />:null}
            </div>
        </>
    )
}

export default CreateResale